const PUBLIC = process.env.PUBLIC_URL || '';

export const AUTH_HERO_SLIDES = [
  {
    img: `${PUBLIC}/images/RFIDGATE.png`,
    fit: 'gate',
    title: 'RFID Gate & Secure Tracking',
    desc: 'Automate entry and exit logging with Sparkle RFID gates. Real-time monitoring for warehouses, showrooms, and secure stock movement.',
  },
  {
    img: `${PUBLIC}/images/RFIDDashboard.png`,
    fit: 'dashboard',
    title: 'Jewellery Intelligence Dashboard',
    desc: 'Track inventory, sales, and RFID tags in one place — built for jewellery retail with live analytics and alerts.',
  },
  {
    img: `${PUBLIC}/images/RFIDPOS.png`,
    fit: 'pos',
    title: 'Handheld RFID POS for Jewellery',
    desc: 'Scan, encode, and sell on the showroom floor. Sparkle RFID handhelds put inventory, sales, jewellery tagging, and reports in one device — built for high-value retail.',
  },
  {
    img: `${PUBLIC}/images/RFIDROBOT.png`,
    fit: 'robot',
    title: 'Automated Jewellery Inventory',
    desc: 'Precision RFID scanning for high-value stock. Sparkle RFID brings automated inventory, secure vault tracking, and showroom accuracy to jewellery retail.',
  },
];
